"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLONE_PRODUCT_TREE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.CLONE_PRODUCT_TREE = (0, gql_1.gql)(`
  mutation CloneProductTree($productTreeId: ID!, $title: String!) {
    cloneProductTree(productTree: {
      id: $productTreeId,
      title: $title,
      clientMutationId: "",
    }) {
      success
      error
      productTree {
        id
      }
    }
  }
`);
